<script>
  import { activeIssueEditable } from '@/ui/pages/conduct/ConductInspectionStore';
  import cloneDeep from 'lodash/cloneDeep';
  import { EventBus } from '@/ui/EventBus';
  import { Events } from '@/ui/events';
  import { d, fromUnixTimestamp } from '@/ui/i18n/i18n';

  export default {
    name: 'InspectionAction',
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isShowingErrors: false,
      };
    },
    computed: {
      itemExecutedAt() {
        return d(fromUnixTimestamp(this.item.executed_at), 'shortDateTime');
      },
      needsBeFilledByConductor() {
        // If settings is not present then it means that we are dealing with issues
        // that were created before the feature `Mixies` was released
        // @see https://zypone.atlassian.net/browse/SL-1338
        if (!Object.prototype.hasOwnProperty.call(this.item, 'settings')) {
          return false;
        }

        return Object.keys(this.item.settings).some(key => this.item.settings[key] === true);
      },
      // Fields has the following convention `<field-name>_required` and `<field-name>_enabled`
      // We need to check if any of the fields are `required`
      hasFieldRequired() {
        return Object.keys(this.item.settings).some(key => {
          if (key.includes('required')) {
            return this.item.settings[key];
          }

          return false;
        });
      },
    },
    created() {
      EventBus.$on(Events.showErrorsInvalidActions, this.onShowErrors);
      EventBus.$on(Events.preSubmitInspection, this.onInspectionSubmit);
    },
    destroyed() {
      EventBus.$off(Events.showErrorsInvalidActions, this.onShowErrors);
      EventBus.$off(Events.preSubmitInspection, this.onInspectionSubmit);
    },
    methods: {
      detailsButtonClicked() {
        this.$store.dispatch('conduct/issueItemModalOpened', this.item);
      },
      onProvideDetailsButtonClick() {
        this.$set(activeIssueEditable, 'value', cloneDeep(this.item));
      },
      onShowErrors({ invalidAction }) {
        if (invalidAction.uuid && invalidAction.uuid === this.item.uuid) {
          this.isShowingErrors = true;
        }
      },
      onInspectionSubmit() {
        this.isShowingErrors = false;
      }
    },
  };
</script>

<template>
  <div v-if="item.visible_for_conductor" class="mb-6">
    <h2 v-if="item.executed_at">
      {{ $t('The issue was raised at "{date}".', { date: itemExecutedAt }) }}
    </h2>
    <h2 v-if="needsBeFilledByConductor">
      <span v-if="hasFieldRequired">*</span> {{ $t('issues.action-information-needs-be-filled') }}
    </h2>
    <h2 v-else>
      {{ $t('issues.action-information', { issueTitle: item.params.title }) }}
    </h2>

    <button
      v-if="!needsBeFilledByConductor"
      class="btn btn-default btn-primary main-button relative"
      @click="detailsButtonClicked"
    >
      {{ $t('See details') }}
    </button>

    <button
      v-if="needsBeFilledByConductor"
      class="btn btn-default btn-primary main-button relative"
      @click="onProvideDetailsButtonClick"
    >
      {{ $t('issues.provide-details') }}
    </button>

    <div v-if="isShowingErrors" class="error-text mt-2 text-red">{{ $t('issues.action-required') }}</div>
  </div>
</template>
